export default __webpack_public_path__ + "static/media/Innovative Head.b8edca4e.jpeg";